import {
    useState
} from 'react';
import {
    Plus, Pin, PinOff, Trash2, Pencil, Check, X, MessageSquare
} from 'lucide-react';
import {
    Button
} from 'shared/components/ui/button';

/**
 * Recents sidebar — new chat, switch, rename (inline), delete, pin.
 * Rendered inline (desktop, when open) or as an overlay (mobile).
 */
export default function SessionsSidebar({
    sessions, currentId, pinned, onNew, onSwitch, onRename, onDelete, onTogglePin
}) {
    const [editId, setEditId] = useState(null);
    const [editVal, setEditVal] = useState('');

    const startEdit = (s) => { setEditId(s.id); setEditVal(s.title); };
    const commitEdit = () => {
        if (editId && editVal.trim()) onRename(editId, editVal.trim());
        setEditId(null);
    };

    return (
        <div className="flex h-full w-full flex-col border-r bg-muted/30">
            <div className="p-2">
                <Button size="sm" variant="outline" className="w-full justify-start" onClick={onNew}>
                    <Plus className="mr-1 h-4 w-4" /> New chat
                </Button>
            </div>
            <div className="flex-1 overflow-y-auto px-1 pb-2">
                {sessions.length === 0 && (
                    <div className="px-2 py-3 text-xs text-muted-foreground">No chats yet.</div>
                )}
                {sessions.map((s) => {
                    const active = s.id === currentId;
                    const isPinned = pinned.has(s.id);
                    return (
                        <div
                            key={s.id}
                            className={`group flex items-center gap-1 rounded px-2 py-1.5 text-sm ${active ? 'bg-background shadow-sm' : 'hover:bg-background/60'}`}
                        >
                            {editId === s.id ? (
                                <>
                                    <input
                                        autoFocus
                                        value={editVal}
                                        onChange={(e) => setEditVal(e.target.value)}
                                        onKeyDown={(e) => { if (e.key === 'Enter') commitEdit(); if (e.key === 'Escape') setEditId(null); }}
                                        className="min-w-0 flex-1 rounded border bg-background px-1 py-0.5 text-xs"
                                    />
                                    <button type="button" onClick={commitEdit} title="Save"><Check className="h-3.5 w-3.5 text-green-600" /></button>
                                    <button type="button" onClick={() => setEditId(null)} title="Cancel"><X className="h-3.5 w-3.5" /></button>
                                </>
                            ) : (
                                <>
                                    <button
                                        type="button"
                                        onClick={() => onSwitch(s.id)}
                                        className="flex min-w-0 flex-1 items-center gap-1.5 text-left"
                                        title={s.title}
                                    >
                                        {isPinned
                                            ? <Pin className="h-3 w-3 shrink-0 text-amber-500" />
                                            : <MessageSquare className="h-3 w-3 shrink-0 text-muted-foreground" />}
                                        <span className="truncate">{s.title}</span>
                                    </button>
                                    <div className="hidden shrink-0 items-center gap-1 group-hover:flex">
                                        <button type="button" onClick={() => onTogglePin(s.id)} title={isPinned ? 'Unpin' : 'Pin'}>
                                            {isPinned ? <PinOff className="h-3.5 w-3.5" /> : <Pin className="h-3.5 w-3.5" />}
                                        </button>
                                        <button type="button" onClick={() => startEdit(s)} title="Rename"><Pencil className="h-3.5 w-3.5" /></button>
                                        <button type="button" onClick={() => onDelete(s.id)} title="Delete"><Trash2 className="h-3.5 w-3.5 text-red-500" /></button>
                                    </div>
                                </>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
